

module.exports = __webpack_require__.stylable.create(
    "Popover2483623448",
    {"classes":{"root":"Popover2483623448__root","arrow":"Popover3641543974__arrow","withArrow":"Popover3641543974__withArrow"},"vars":{},"stVars":{"contentArrowSize":"8px"},"keyframes":{}},
    "",
    2,
    "Popover2483623448",
    null
);
